import * as React from "react";
import { request } from "../../../../services/cpln";
import { IS_DEPLOYMENT_ENV_PROD, REFERRAL_SERVICE_PARTNER_URL } from "../../../../envVariables";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { Loader } from "../../../../components/layout/loader";
import { setAccountExternalId } from "../../../../store/uiDataSlice";
import { sentryLog } from "../../../../tools/sentry";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { formSetValue } from "../../../gvc/testNewForm/utils";

interface Props extends React.PropsWithChildren {}
export const LayerExternalId: React.FC<Props> = ({ children }) => {
  const dispatch = useAppDispatch();
  const { id: formId } = useCpFormContext();
  const userEmail = useAppSelector((state) => state.user.email);
  const externalId = useAppSelector((state) => state.uiData.accountExternalId);
  const [processed, setProcessed] = React.useState(false);

  React.useEffect(() => {
    process();
  }, []);

  async function process() {
    if (!externalId) {
      setProcessed(true);
      return;
    }

    try {
      const { data } = await request({
        url: `${REFERRAL_SERVICE_PARTNER_URL}/referral/${externalId}`,
        service: "self",
      });

      let { accountName, company, fullName, phone, address, email } = data;
      if (email !== userEmail) {
        dispatch(setAccountExternalId(""));
        setProcessed(true);
        return;
      }
      if (!address) {
        address = {};
      }
      const { city, country, line1, line2, postalCode, state } = address;

      // Store externalId in form meta for useInformExternal to use later
      formSetValue(formId, `meta.externalId`, externalId);

      // Populate form fields from referral data
      formSetValue(formId, `account.accountName`, accountName || "");
      formSetValue(formId, `account.fullName`, fullName || "");
      formSetValue(formId, `account.company`, company || "");
      formSetValue(formId, `account.phone`, phone || "");
      formSetValue(formId, `address.country`, country || "");
      formSetValue(formId, `address.state`, state || "");
      formSetValue(formId, `address.city`, city || "");
      formSetValue(formId, `address.address1`, line1 || "");
      formSetValue(formId, `address.address2`, line2 || "");
      formSetValue(formId, `address.postalCode`, postalCode || "");

      dispatch(setAccountExternalId(""));
      setProcessed(true);
    } catch (e) {
      if (IS_DEPLOYMENT_ENV_PROD) {
        sentryLog("account external id fetch failed", {
          "data.externalId": externalId,
          "data.message": e.message,
        });
      }
      dispatch(setAccountExternalId(""));
      setProcessed(true);
    }
  }

  if (!processed) {
    return <Loader />;
  }

  return children;
};
